import $ from "jquery";
// import CONFIG from "@bd-core/config";

export default class NumberAnimator2 {
  constructor() {
    this.currNum = 0;
    this.$stat = $("#number");
    this.digits = 6;

    this.elms = {
      container: "#numberScrollContainer",
    }
  }

  createDigit() {
    const group = document.createElement('div');
    group.className = 'digit-group';

    const list = document.createElement('div');
    list.className = 'digit-list';
    list.innerHTML = Array.from({ length: 10 }, (_, i) => `<div class="digit">${i}</div>`).join('');

    group.appendChild(list);
    return group;
  }

  init() {
    $(this.elms.container).html('');
    
    for (let i = 0; i < this.digits; i++) {
      $(this.elms.container).append(this.createDigit());
    }
  }

  animate(targetNumber) {
    const theTargetNumber = targetNumber > 0 ? targetNumber : 0;
    const paddedNumber = String(theTargetNumber).padStart(this.digits, '0');

    $(this.elms.container).find('.digit-list').each(function(i) {
      const digit = parseInt(paddedNumber[i], 10);
      $(this).css('transform', `translateY(-${digit}em)`);
    });

    const isNegative = targetNumber < 0;
    if (isNegative) {
      $(this.elms.container).parent(".team-screen__score").addClass('is-negative');
    } else {
      $(this.elms.container).parent(".team-screen__score").removeClass('is-negative');
    }
  }
}
